import React from 'react'

import { TableContainer, Table } from '@material-ui/core'
import {
  DetailPanelHeader,
  DetailPanelBody,
  DetailPanelFooter
} from './DetailPanelContents/DetailPanelContents'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'

const DetailPanel = ({ rowData, inputChanged, translate, openCommentModal, isInputStage }) => {
  let rowDetail = null
  const detailList = rowData?.result_kpi || []
  const kpiTypeDate = !!rowData?.uom?.is_date
  const kpiFrequencyCode = rowData?.frequency_type?.value_list_code
  const isAdopted = !!rowData?.is_adopt
  const isItemInputStage = !!rowData?.is_input_data && !!isInputStage

  rowDetail = (
    <DetailPanelBody
      frequencyCode={kpiFrequencyCode}
      detailList={detailList}
      rowChanged={updatedRow => {
        let updatedResults = []
        if (rowData.result_kpi) {
          updatedResults = [...rowData.result_kpi].map(item => {
            if (+item.result_kpi_id === +updatedRow.result_kpi_id) {
              return { ...item, ...updatedRow }
            }
            return item
          })
        }
        inputChanged({ ...rowData, result_kpi: updatedResults })
      }}
      kpiTypeDate={kpiTypeDate}
      translate={translate}
      inputDisabled={!isItemInputStage}
      adopted={isAdopted}
    />
  )
  return (
    <TableContainer style={{ maxHeight: 300, overflow: 'auto' }}>
      <Table stickyHeader>
        <DetailPanelHeader
          openCommentModal={openCommentModal}
          translate={translate}
          frequencyCode={kpiFrequencyCode}
          detailList={detailList}
          rowChanged={updatedRow => {
            let updatedResults = []
            if (rowData.result_kpi) {
              updatedResults = [...rowData.result_kpi].map(item => {
                if (+item.result_kpi_id === +updatedRow.result_kpi_id) {
                  return { ...item, ...updatedRow }
                }
                return item
              })
            }
            inputChanged({ ...rowData, result_kpi: updatedResults })
          }}
        />
        {rowDetail}
        <DetailPanelFooter rowData={rowData} translate={translate} />
      </Table>
    </TableContainer>
  )
}

export default withTranslate(DetailPanel)
